import { Chip, Box } from '@mui/material';
import { keyframes } from '@emotion/react';

const pulse = keyframes`
  0% { transform: scale(1); opacity: .7; }
  50% { transform: scale(1.35); opacity: 1; }
  100% { transform: scale(1); opacity: .7; }
`;

export default function LiveBadge({ connected, msSinceLast, label, color }) {
    const text =
        connected ? (label || 'AO VIVO') : 'Reconectando…';

    return (
        <Chip
            size="small"
            color={color || (connected ? 'success' : 'warning')}
            variant={connected ? 'filled' : 'outlined'}
            label={
                <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
                    <Box sx={{
                        width: 8, height: 8, borderRadius: '50%',
                        bgcolor: 'currentColor',
                        animation: connected ? `${pulse} 1.2s ease-in-out infinite` : 'none'
                    }} />
                    <span>{text}</span>
                    {typeof msSinceLast === 'number' && (
                        <span style={{ opacity:.75 }}>• {Math.max(0, Math.floor(msSinceLast/1000))}s</span>
                    )}
                </Box>
            }
            sx={{ fontWeight: 600 }}
        />
    );
}
